import { useState, useMemo } from "react"

const useFinalResponseAssessmentContent = (responses) => {
    const finalResponsePre = useMemo(
        () =>
            responses.length
                ? responses.map((response) => ({
                      choiceId: response.choiceId,
                      questionId: response.questionId,
                      responseId: response.responseId,
                      status: "responded",
                  }))
                : [],
        [responses]
    )
    const [finalResponseAssessmentContent, setFinalResponseAssessmentContent] = useState(finalResponsePre)
    return { finalResponseAssessmentContent, setFinalResponseAssessmentContent }
}

export default useFinalResponseAssessmentContent
